import { customerValidator } from "../../../helpers";

export const initialState = {
  values: {
    password: '',
    confirmPassword: ''
  },
  errors: {}
}

export function validateValues(values) {
  
  const errors = {}
  
  errors.password = customerValidator.validatePassword(values.password)
  
  if(!errors.password) {
    if(values.password && values.password !== values.confirmPassword){
      errors.confirmPassword = "Confirm password doesn't match"
    }
  }

  return errors
}
